<template>
  <layout-basic>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            class="search-box"
            placeholder="Search Courses"
            prepend-icon="fa-search"
            v-model="search"
            type="text"
            clearable
            clear-icon="fa-times"
            @click:clear="resetSearch"
            @change="applySearch"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="course-button-wrapper">
          <v-btn
            color="primary"
            outlined
            @click.prevent="showCreatePanel"
            class="mr-5"
          >
            <v-icon class="mr-1" small>fa-plus</v-icon>Add Course
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="courses"
              item-key="id"
            >
              <template v-slot:item.name="{ item }">
                <table-thumb :thumb="item"></table-thumb>
                <span class="ml-2">{{ item.name }}</span>
              </template>
              <template v-slot:item.published="{ item }">
                <v-icon v-if="item.published" color="green" small
                  >fa-check</v-icon
                >
                <v-icon v-else color="red" small>fa-times</v-icon>
              </template>
              <template v-slot:item.completion_progress="{ item }">
                <v-progress-linear
                  height="20"
                  color="blue"
                  :value="item.completion_progress"
                ></v-progress-linear>
              </template>
              <template v-slot:item.id="{ item }">
                <v-select
                  v-if="screenSize === 'tablet' || screenSize === 'mobile'"
                  v-model="selectedAction"
                  :items="getActionList(item)"
                  item-text="name"
                  item-value="id"
                  placeholder="Select Action"
                  @change="performAction(item)"
                  :item-disabled="action => action.is_course_archived"
                ></v-select>

                <template v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="mr-1 action-button action-button-txt"
                        small
                        outlined
                        @click.prevent="showCourseDetail(item.id)"
                        :disabled="item.is_course_archived"
                      >
                      Details
                      </v-btn>
                    </template>
                    <span>Show Course Details</span>
                  </v-tooltip>
                  <v-tooltip
                    bottom
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="mr-1 action-button action-button-txt"
                        small
                        outlined
                        @click.prevent="showEditPanel(item.id)"
                        :disabled="item.is_course_archived"
                      >
                        Edit
                      </v-btn>
                    </template>
                    <span>Edit Course</span>
                  </v-tooltip>
                  <v-tooltip
                    bottom
                    v-if="!item.is_course_archived"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        :to="'/partner/courses/' + item.id"
                        class="mr-1 action-button action-button-txt"
                        small
                        outlined
                      >
                        Content
                      </v-btn>
                    </template>
                    <span>Add & manage the course content</span>
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="mr-1 action-button action-button-txt"
                        small
                        outlined
                        disabled
                      >
                        Content
                      </v-btn>
                    </template>
                    <span>Add & manage the course content</span>
                  </v-tooltip>
                  <v-tooltip
                    bottom
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        @click.prevent="showEnrolPanel(item.id)"
                        class="mr-1 action-button action-button-txt"
                        small
                        outlined
                        :disabled="item.is_course_archived"
                      >
                        Push Content
                      </v-btn>
                    </template>
                    <span>Push Course Content</span>
                  </v-tooltip>
                  <template>
                    <v-tooltip v-if="item.hasOwnProperty('test')" bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          class="mr-1 action-button action-button-txt"
                          small
                          outlined
                          @click.prevent="editTest(item.test.data.id)"
                          width="83px"
                          :disabled="item.is_course_archived"
                        >
                          Edit Test
                        </v-btn>
                      </template>
                      <span>Edit Test</span>
                    </v-tooltip>
                    <v-tooltip v-else bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          class="mr-1 action-button action-button-txt"
                          small
                          outlined
                          @click.prevent="createTest(item.id)"
                          :disabled="item.is_course_archived"
                        >
                          Create Test
                        </v-btn>
                      </template>
                      <span>Create Test</span>
                    </v-tooltip>
                    </template>
                    <v-tooltip bottom class="mr-5" v-if="!item.is_course_archived">
                    <template v-slot:activator="{ on }">
                      <v-btn :id="item.id" v-on="on" outlined x-small color="$improve-grey-900" class="Frame-61 mr-1"
                        @click.prevent="archiveCourse(item.id, 1)">
                        <v-img class="archiveBtnImg" src="static/archive-icon.svg"></v-img>
                      </v-btn>
                    </template>
                    <span>Archive Course</span>
                  </v-tooltip>
                  <v-tooltip bottom class="mr-5" v-else>
                    <template v-slot:activator="{ on }">
                      <v-btn :id="item.id" v-on="on" outlined x-small color="$improve-grey-900" class="Frame-61 mr-1"
                        @click.prevent="archiveCourse(item.id, 0)">
                        <v-img class="archiveBtnImg" src="static/unarchive-icon.svg"></v-img>
                      </v-btn>
                    </template>
                    <span>UnArchive Course</span>
                  </v-tooltip>
                    <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        x-small
                        outlined
                        color="$improve-grey-900"
                        class="Frame-61"
                        @click.prevent="deleteCourse(item.id)"
                        :disabled="item.is_course_archived"
                      >
                        <v-icon small>fa fa-trash</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete this course and all User data for it</span>
                  </v-tooltip>
                </template>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import courseAPI from '@/api/course.js';
import testAPI from '@/api/test.js';
import LayoutBasic from '@/layouts/PartnerHub';
import TableThumb from '@/components/partner/course/TableThumb';
import EditCourse from '@/components/partner/course/Edit';
import CreateCourse from '@/components/partner/course/Create';
import EnrolUsers from '@/components/partner/course/Enrol';
import ManageDeadlines from '@/components/partner/course/ManageDeadlines';
import RemoveUsers from '@/components/partner/course/RemoveUsers';
import CreateTest from '@/components/partner/course/AddTest';
import ShowCourseDetail from '@/components/partner/course/ShowCourseDetail';

import { screensize } from '../../utils/screensize';

// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
  name: 'CoursesPartner',
  components: {
    LayoutBasic,
    TableThumb,
  },
  data() {
    return {
      headers: [
        { text: 'Course', value: 'name' },
        { text: '', value: 'id', sortable: false, align: 'end' },
      ],
      selectedAction: null,
      screenSize: currentScreenSize,
      courses: [],
      search: '',
      pagination: {},
      options: {},
      loading: false,
      searchParams: '',
      selected: [],
      confirmDelete: 'Are you sure you want to delete this course?',
      publishNotification:
        "Selected course(s) can not be published, it seems you didn't add any video for this. Please upload at least one video to publish it.",
      errorMessage: "Oops something went wrong",  
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    hasTest: function () {
      return this.test == null ? false : true;
    },
    test: function () {
      return this.course.hasOwnProperty('test')
        ? this.course.test.data.id
        : null;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getCourses();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
    this.handleResize();

    // Add event listener for screen size changes
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    getActionList(item) {
      const actions = [];

      if (!item.is_course_copied || item.is_course_copied) {
        actions.push({
          name: 'Details',
          action: () => this.showCourseDetail(item.id),
          is_course_archived: item.is_course_archived
        });
      }

      if (!item.is_course_copied || item.is_course_copied) {
        actions.push({
          name: 'Edit',
          action: () => this.showEditPanel(item.id),
          is_course_archived: item.is_course_archived
        });
      }

      if (!item.is_course_copied || item.is_course_copied) {
        actions.push({
          name: 'Content',
          action: () => this.$router.push('/partner/courses/' + item.id),
          is_course_archived: item.is_course_archived
        });
      }

      if (!item.is_course_copied || item.is_course_copied) {
        actions.push({
          name: 'Push Content',
          action: () => this.showEnrolPanel(item.id),
          is_course_archived: item.is_course_archived
        });
      }

      if (item.hasOwnProperty('test')) {
        actions.push({
          name: 'Edit Test',
          action: () => this.editTest(item.test.data.id),
          is_course_archived: item.is_course_archived
        });
      } else {
        actions.push({
          name: 'Create Test',
          action: () => this.createTest(item.id),
          is_course_archived: item.is_course_archived
        });
      }

      if(item.is_course_archived){
        actions.push({
          name: 'UnArchive Course',
          action: () => this.archiveCourse(item.id, 0),
        });
      }else{
        actions.push({
          name: 'Archive Course',
          action: () => this.archiveCourse(item.id, 1),
        });
      }

      actions.push({
        name: 'Delete',
        action: () => this.deleteCourse(item.id),
        is_course_archived: item.is_course_archived
      })

      return actions;
    },
    performAction(item) {
      const selectedOption = this.getActionList(item).find(
        (option) => option.name === this.selectedAction
      );
      if (selectedOption) {
        selectedOption.action();
      }
      setTimeout(() => {
        this.selectedAction = null;
      }, 0);
    },
    // Method to handle screen size changes
    handleResize() {
      this.screenSize = getCurrentScreenSize();
    },
    createTest(id) {
      testAPI.createTest(id).then((resp) => {
        this.$router.push('/partner/courses/test/' + resp.data.data.id);
      });
    },
    deleteCourse(id) {
      this.$snotify.confirm(this.confirmDelete, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processDeleteCourse(toast, id),
          },
        ],
      });
    },
    processDeleteCourse(toast, id) {
      this.$snotify.remove(toast.id);
      courseAPI.deleteCourse(id).then((response) => {
        this.getCourses();
      });
    },
    editTest(id) {
      this.$router.push('/partner/courses/test/' + id);
    },
    publishCourses() {
      let selected = this.selected.map(function (x) {
        return x.id;
      });
      let totalVideos = this.selected.map(function (x) {
        return x.total_videos;
      });
      for (let i = 0; i <= totalVideos.length; i++) {
        if (totalVideos[i] <= 0) {
          this.$snotify.warning(this.publishNotification);
        } else {
          courseAPI.togglePublish(selected[i], true).then((resp) => {
            this.getCourses();
          });
        }
      }
    },
    unpublishCourses() {
      let selected = this.selected.map(function (x) {
        return x.id;
      });
      courseAPI.togglePublish(selected, false).then((resp) => {
        this.getCourses();
      });
    },
    applySearch() {
      this.options.page = 1;
      this.searchParams = "";
      if (this.search != null) {
        this.searchParams =
          '&search=name:' +
          this.search
      }
      this.getCourses();
    },
    resetSearch() {
      this.search = '';
      this.applySearch();
    },
    getCourses() {
      this.loading = true;
      courseAPI
        .getCourses(this.params + '&include=thumbnail,test', this.searchParams)
        .then((resp) => {
          this.courses = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
          // this.addAction(resp.data.data);
        });
    },
    setEventBus() {
      EventBus.$on('COURSES_UPDATED', (payload) => {
        this.params = payload;
        this.getCourses();
      });
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditCourse,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showCreateTestPanel(id) {
      this.$showPanel({
        component: CreateTest,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    showCreatePanel() {
      this.$showPanel({
        component: CreateCourse,
        props: {
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showEnrolPanel(id) {
      this.$showPanel({
        component: EnrolUsers,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showManageDeadlinesPanel(id) {
      this.$showPanel({
        component: ManageDeadlines,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showRemoveUsersPanel(id) {
      this.$showPanel({
        component: RemoveUsers,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    /**
     * Show the course modal
     */
    showCourseDetail(id) {
      this.$showPanel({
        component: ShowCourseDetail,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    archiveCourse(id,archived){
      let confirmArchive = 'Are you sure you want to archive the course? You have to unarchive the course if you would like to use it in the future';
      
      if(!archived)
       confirmArchive = 'Are you sure you wish to unarchive this course?';

      this.$snotify.confirm(confirmArchive, {
        backdrop: 0.3, buttons: [
          { text: 'Cancel',className: 'toast-cancel-button', },
          {
            text: 'Continue',className: 'toast-continue-button',
            action: (toast) => this.processArchiveCourse(toast, id, archived),
          }         
        ],
      });
    },
    processArchiveCourse(toast, id,archived){
      this.$snotify.remove(toast.id);
      this.loading = true;
      courseAPI.archiveCourse(id,archived).then(() => {
        this.getCourses();
        this.loading = false;
      }).catch(() => {
        this.$snotify.error(this.errorMessage);   
        this.loading = false;
      });
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.screenSize = null;
  },
};
</script>

<style scoped>
.course-button-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1em;
}

.archiveBtnImg{
  width: 20px;
}

@media (max-width: 960px) {
  .course-button-wrapper {
    justify-content: start;
  }
}
.v-btn.v-btn--disabled{
  color: #fff !important;
  pointer-events: auto;
  cursor: not-allowed;
  background-color: rgba(0, 0, 0, 0.26) !important
}
</style>
